import React, { Component } from 'react'
import {
    SearchOutlined,
} from '@ant-design/icons';
import { httpGet, httpPost, httpUrl } from '../../api/httpClient';
import { Table, Input, Button, Modal, Checkbox, Divider } from 'antd'

import SelectBox from "../../components/common/SelectBox";
import NoticeDetail from "../../components/modal/NoticeDetail";
import ModifyNotice from "../../components/modal/ModifyNotice";
import ModifyNoticeDialog from "../../components/modal/ModifyNoticeDialog";
import moment from "moment";
const Search = Input.Search;
export default class NoticeList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchStr: "",
            pagination: {
                total: 0,
                current: 1,
            },
            deleted: 0,
            list: [],
            noticeModalVisible: false,
            noticeModifyModalVisible: false,
            createNoticeVisible: false,
            selectedData: {},
            selectedRow: 0,
        };
    }

    handleTableChange = (pagination) => {
        const pager = { ...this.state.pagination };
        pager.current = pagination.current;
        this.setState({
            pagination: pager
        }, () => this.getNoticeList());
    };


    onSearch = (value) => {
        this.setState({
            searchStr: value,
        }, () => this.getNoticeList());
    };

    getNoticeList = () => {
        const { searchStr, deleted } = this.state
        let pageNum = this.state.pagination.current;
        httpGet(httpUrl.noticeList, [deleted, pageNum, 10, searchStr], {})

            .then(res => {
                const pagination = { ...this.state.pagination }
                pagination.total = res.data.totalCount
                this.setState({
                    list: res.data.notices,
                    pagination,
                })
            })

    }


    onDeleteHandleChange = () => {
        this.setState({
            deleted: !this.state.deleted,
            pagination: {
                ...this.state.pagination,
                current: 1
            }
        }, () => this.getNoticeList());
    }

    onDeleted = (row) => {
        let self = this;
        let deleteText = this.state.deleted ? "재등록" : "삭제"
        Modal.confirm({
            title: `QA ${deleteText}`,
            content: `"${row.title}" 을/를 ${deleteText} 하시겠습니까? 재등록하실 경우 목록에서 조회가 가능합니다.`,
            okText: "확인",
            cancelText: " 취소",
            onOk() {
                httpPost(httpUrl.noticeUpdate, [], {
                    idx: row.idx,
                    deleted: self.state.deleted ? 0 : 1,
                }).then((res) => {
                    if (res.data === "SUCCESS") {
                        Modal.info({
                            title: `${deleteText} 완료`,
                            content: "완료했습니다. 목록에서 조회가 불가능합니다."
                        })
                        self.getNoticeList();
                    } else {
                        Modal.error({
                            title: `${deleteText} 오류`,
                            content: "오류가 발생했습니다. 관리자에게 문의해주세요."
                        });
                    }
                })
            }
        })
    }


    componentDidMount() {
        this.getNoticeList();
    }

    onClose = () => {
        this.setState({
            noticeModalVisible: false,
            noticeModifyModalVisible: false,
            createNoticeVisible: false,
            // pagination: {...this.state.pagination, current: 1}
        })
        this.getNoticeList();
    }

    changeShowContent = (idx) => {
        if (this.state.showContent === idx) {
            this.setState({
                showContent: 0
            })
        }
        else
            this.setState({
                showContent: idx
            })
    }

    render() {
        const { selectedData, selectedRow } = this.state;

        const columns = [
            {
                title: "번호",
                dataIndex: "idx",
                className: "column-center",
                width: "10%"
            },
            {
                title: "제목",
                dataIndex: "title",
                className: "",
                width: "50%",
                render: (data, row) => (
                    <>
                        <div
                            onClick={() => {
                                this.changeShowContent(row.idx);
                            }}>
                            <div className="board-title">
                                {data}
                                <div className="board-date">{moment(row.createDate).format("YYYY-MM-DD")}</div>
                            </div>
                        </div>
                        {this.state.showContent === row.idx && row.content !== null && (
                            <div>
                                <Divider />
                                <div className="boardContent">
                                    {row.content.split("\n").map((line, index) => {
                                        return (
                                            <span key={index}>

                                                <div style={{ marginLeft: 12 }}>
                                                    {line}
                                                </div>
                                            </span>
                                        )
                                    })}
                                </div>
                            </div>
                        )}
                    </>
                )

            },
            {
                title: "",
                className: "column-center",
                width: "8%",
                render: (row) => (
                    <Button
                        onClick={() => {
                            this.setState({
                                noticeModifyModalVisible: true,
                                selectedData: row,
                            });
                        }}
                    >수정</Button>
                )
            },
            {
                title: "",
                className: "column-center",
                width: "8%",
                render: (row) => (
                    <div>
                        {!this.state.deleted ?
                            <Button
                                onClick={() => {
                                    this.onDeleted(row);

                                }}
                            >삭제</Button>
                            :
                            <Button
                                onClick={() => {
                                    this.onDeleted(row);

                                }}
                            >재등록
                            </Button>

                        }
                    </div>
                )
            },
        ];


        return (
            <div>
                <div style={{ width: "100%" }}>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        marginTop: 40,
                        marginBottom: 20,
                        alignItems: 'center'
                    }}>

                        {this.state.noticeModalVisible &&
                            <NoticeDetail
                                data={this.state.selectedData}
                                title="상세보기"
                                visible={this.state.noticeModalVisible}
                                onClose={this.onClose}
                            />

                        }

                        {this.state.noticeModifyModalVisible &&
                            <ModifyNotice
                                data={this.state.selectedData}
                                title="수정하기"
                                visible={this.state.noticeModifyModalVisible}
                                onClose={this.onClose}

                            />
                        }


                        {this.state.createNoticeVisible &&
                            <ModifyNoticeDialog
                                title="등록하기"
                                visible={this.state.createNoticeVisible}
                                onClose={this.onClose}
                            />
                        }


                        <Search
                            className="search-input"
                            placeholder={`제목으로 검색하세요`}
                            enterButton={<SearchOutlined />}
                            allowClear
                            onSearch={this.onSearch}
                            style={{ width: 400 }}
                        />
                        <div>
                            <Button
                                className="regist-btn"
                                style={{ marginRight: 20 }}
                                onClick={() => {
                                    this.setState({
                                        createNoticeVisible: true,
                                    })
                                }}
                            >등록</Button>
                            <Checkbox onClick={this.onDeleteHandleChange}>
                                삭제 목록 보기
                            </Checkbox>
                        </div>
                    </div>
                </div>
                <Table
                    rowKey={(record) => record.idx}
                    columns={columns}
                    dataSource={this.state.list}
                    style={{ marginBottom: "10px", marginTop: '10px' }}
                    pagination={this.state.pagination}
                    onChange={this.handleTableChange}
                />
            </div>
        )
    }
}
